const normalizeId = (value: unknown) => `${value ?? ""}`.trim()

const uniqueIds = (values: unknown[]) =>
  Array.from(new Set(values.map(normalizeId).filter(Boolean)))

export const propertyIdsForContactOrderWorkOrders = (workOrders: WorkOrder[]) =>
  uniqueIds(workOrders.map((order) => order.property_id))

export const recipientCustomerIdsForContactOrderWorkOrders = (workOrders: WorkOrder[]) =>
  uniqueIds(
    workOrders.flatMap((order) =>
      (order.recipients ?? []).map((recipient: { customer_id?: unknown }) => recipient.customer_id),
    ),
  )

export const hasContactPointsForRecipients = ({
  workOrders,
  contactPoints,
}: {
  workOrders: WorkOrder[]
  contactPoints: ContactPoint[]
}) => {
  const recipientIds = recipientCustomerIdsForContactOrderWorkOrders(workOrders)

  if (!recipientIds.length) return true

  const coveredCustomerIds = new Set(
    contactPoints.map((point) => normalizeId(point.customer_id)).filter(Boolean),
  )

  return recipientIds.every((customerId) => coveredCustomerIds.has(customerId))
}

export const missingRecipientCustomerIdsForContactPoints = ({
  workOrders,
  contactPoints,
}: {
  workOrders: WorkOrder[]
  contactPoints: ContactPoint[]
}) => {
  const coveredCustomerIds = new Set(
    contactPoints.map((point) => normalizeId(point.customer_id)).filter(Boolean),
  )

  return recipientCustomerIdsForContactOrderWorkOrders(workOrders).filter(
    (customerId) => !coveredCustomerIds.has(customerId),
  )
}

export const mergeContactPointsById = (base: ContactPoint[], extra: ContactPoint[]) => {
  const byId = new Map<string, ContactPoint>()
  for (const point of [...base, ...extra]) {
    const id = normalizeId(point.id)

    if (!id) continue

    byId.set(id, point)
  }

  return Array.from(byId.values())
}
